import React, { useState, useMemo, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';
import { isEmpty, isArray } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

import { Spinner, Table } from '~/components';
import { number } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';

export default function ValidarDialog({
  valueProp,
  open,
  mensagem,
  titulo,
  textoBtnOK,
  textoBtnCancel,
  onClose,
  modal,
  arquivo,
  setStatusComErroValidacao,
  setPlanilhaClienteErro,
}) {
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidandoDados, setIsValidandoDados] = useState(false);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (!open) {
      setIsValidandoDados(false);
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    try {
      setIsLoading(true);
      onClose();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleOk = async () => {
    setIsValidandoDados(true);
    try {
      const { data } = await api.get('/uploadplanilhacliente/validar', {
        params: { arquivo },
        paramsSerializer: (param) => qs.stringify(param),
      });
      setIsValidandoDados(false);
      if (isEmpty(data)) {
        toast.success(
          'A planilha foi validada com sucesso! Agora, você pode prosseguir com o processo de gravação na base de dados!'
        );
        setStatusComErroValidacao(true);
      } else {
        toast.error(
          'A planilha apresentou algumas inconsistências! Favor verificar!'
        );
        setPlanilhaClienteErro(data);
        onClose();
        setStatusComErroValidacao(false);
        return;
      }
    } catch (err) {
      toast.error(
        'A planilha apresentou algumas inconsistências! Favor verificar!'
      );
      setIsValidandoDados(false);
      if (isArray(err)) {
        err.map((e) => toast.error(e));
        setStatusComErroValidacao(true);
        return;
      }
    }

    const recordResult = {
      acao: value,
    };

    try {
      setIsLoading(true);
      onClose(recordResult);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div>
      ) : (
        ''
      )}

      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth={modal}
        onEntering={handleEntering}
        aria-labelledby="confirmation-dialog-title"
        open={open}
        PaperProps={{
          style: {
            height: '30vh', // Define a altura do dialog
            width: '35vh',
            maxHeight: 'none', // Remove o limite de altura
          },
        }}

        // {...other}
      >
        {/* <DialogTitle id="confirmation-dialog-title">Confirmar</DialogTitle> */}
        <DialogTitle id="confirmation-dialog-title">{titulo}</DialogTitle>
        <DialogContent dividers>
          {/* <span>{mensagem}</span> */}
          <br />

          <S.WrapperCab>
            {isValidandoDados ? (
              <div style={{ zIndex: 999999 }}>
                Aguarde....
                <Spinner loading />
              </div>
            ) : (
              'Clique no botão validar agora para analisar a planilha!'
            )}
          </S.WrapperCab>

          <br />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleOk}
            color="primary"
            variant="outlined"
            disabled={isValidandoDados}
          >
            {' '}
            {textoBtnOK}{' '}
          </Button>
          <Button
            autoFocus
            onClick={handleCancel}
            color="secondary"
            variant="outlined"
          >
            {' '}
            {textoBtnCancel}{' '}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ValidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  valueProp: PropTypes.string.isRequired,
  mensagem: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  textoBtnOK: PropTypes.string.isRequired,
  textoBtnCancel: PropTypes.string.isRequired,
  modal: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']),
  setStatusComErroValidacao: PropTypes.func.isRequired,
  setPlanilhaClienteErro: PropTypes.func.isRequired,
  arquivo: PropTypes.string.isRequired,
};

ValidarDialog.defaultProps = {
  valueProp: '',
  open: false,
  mensagem: '',
  titulo: 'CONFIRMAR',
  textoBtnOK: 'Ok',
  textoBtnCancel: 'Cancel',
  modal: 'xs',
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
